import { RichText } from 'prismic-reactjs';
import { ICooperation } from './interfaces';
import {
  ButtonWrapper,
  Description,
  Title,
  Wrapper,
} from './cooperation.styles';
import { useEffect, useRef, useState } from 'react';
import { Routes } from 'models/enums/routes';
import { StyledLinkButton } from '../ButtonWithGradientHover/buttonWithGradientHover.styles';

export const Cooperation = ({
  title,
  description,
  description2,
  text,
  titleAs,
}: ICooperation) => {
  const ref = useRef<any>();
  const [wrapperHeight, setWrapperHeight] = useState<number>(0);

  useEffect(() => {
    setWrapperHeight(ref.current.clientHeight);
  }, []);

  return (
    <Wrapper ref={ref} height={wrapperHeight / 2}>
      <div>
        <Title as={titleAs && titleAs}>{title}</Title>
        <Description>
          {RichText.asText(description)} {RichText.asText(description2)}
        </Description>
        <ButtonWrapper>
          <StyledLinkButton href={Routes.EstimateProject}>
            {RichText.asText(text)}
          </StyledLinkButton>
        </ButtonWrapper>
      </div>
    </Wrapper>
  );
};
